$(document).ready(function(){
  setTimeout(() => {
    let targets = $(".product-main-slide .image-wrap").each(function(){
      if ($(this).find('img').attr('data-zoom') != undefined) {
        $(this).wrap('<span style="display:inline-block"></span>')
        .css('display', 'block')
        .parent()
        .zoom({
          url: $(this).find('img').attr('data-zoom')
        });
      }
    }); 
  }, 2500);
})